export enum TextType {
  TEXT1 = "text1",
  TEXT2 = "text2",
  TEXT3 = "text3"
}

export enum TextWeight {
  BOLD = "bold",
  MEDIUM = "medium",
  NORMAL = "normal"
}
